// import React, { useState, useEffect } from 'react';
// import './ViewMeetings.css';

// const ViewMeetings = () => {
//   const [meetings, setMeetings] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [attendance, setAttendance] = useState({});
//   const [userRole, setUserRole] = useState(""); // Store user role
//   const [userId, setUserId] = useState(""); // Store logged-in user's ID

//   useEffect(() => {
//     const savedAttendance = localStorage.getItem('attendance');
//     if (savedAttendance) {
//       setAttendance(JSON.parse(savedAttendance));
//     }

//     // Fetch user role & ID from local storage (assuming they are stored)
//     const storedRole = localStorage.getItem('role'); // "admin" or "member"
//     const storedUserId = localStorage.getItem('userId'); // Store logged-in user's ID

//     setUserRole(storedRole);
//     setUserId(storedUserId);

//     const fetchMeetings = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('token')}`,
//           },
//         });

//         if (!response.ok) throw new Error(`Error fetching meetings: ${response.status}`);

//         const data = await response.json();
//         setMeetings(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error(error);
//         setMeetings([]);
//       }
//     };

//     const fetchUsers = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('token')}`,
//           },
//         });

//         if (!response.ok) throw new Error(`Error fetching users: ${response.status}`);

//         const data = await response.json();
//         console.log("Fetched Users:", data);

//         if (Array.isArray(data)) {
//           setUsers(data);
//         } else {
//           console.error("Expected an array but got:", data);
//           setUsers([]);
//         }
//       } catch (error) {
//         console.error(error);
//         setUsers([]);
//       }
//     };

//     fetchMeetings();
//     fetchUsers();
//   }, []);

//   const handleAttendanceChange = async (meetingId, targetUserId, attended) => {
//     if (userRole !== "admin") return; // Only admin can modify attendance

//     setAttendance((prevState) => {
//       const updatedAttendance = { ...prevState };
//       if (!updatedAttendance[meetingId]) {
//         updatedAttendance[meetingId] = {};
//       }

//       if (attended) {
//         updatedAttendance[meetingId][targetUserId] = attended;
//       } else {
//         delete updatedAttendance[meetingId][targetUserId];
//       }

//       localStorage.setItem('attendance', JSON.stringify(updatedAttendance));
//       return updatedAttendance;
//     });

//     try {
//       const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting/${meetingId}/attendance`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${localStorage.getItem('token')}`,
//         },
//         body: JSON.stringify({
//           userId: targetUserId,
//           attended,
//         }),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         console.log('✅ Attendance updated successfully:', result);
//       } else {
//         console.error('❌ Error updating attendance:', result.message || 'Unknown error');
//       }
//     } catch (error) {
//       console.error('❌ Error updating attendance:', error);
//     }
//   };

//   return (
//     <div className="contain">
//       <main className="main-content">
//         <div className="review-meetings">
//           <h2>View Attendance</h2>

//           <table className="table-heading">
//             <thead>
//               <tr>
//                 <th>User Name</th>
//                 {meetings.map((meeting) => {
//                   const date = new Date(meeting.date);
//                   const formattedDate = `${date.getDate()}-${date.toLocaleString('en-GB', { month: 'short' })}-${date.getFullYear()}`;
//                   return <th key={meeting._id}>{formattedDate}</th>;
//                 })}
//               </tr>
//             </thead>

//             <tbody>
//               {users.length > 0 ? (
//                 users
//                   .filter((user) => userRole === "admin" || user._id === userId) // Admins see all, members see only themselves
//                   .map((user) => (
//                     <tr key={user._id}>
//                       <td>{user.firstName} {user.lastName}</td>
//                       {meetings.map((meeting) => (
//                         <td key={meeting._id}>
//                           <input
//                             type="checkbox"
//                             checked={attendance[meeting._id]?.[user._id] ?? !!meeting.attendees?.find((att) => att.userId === user._id)?.attended}
//                             onChange={(e) => handleAttendanceChange(meeting._id, user._id, e.target.checked)}
//                             disabled={userRole !== "admin"} // Only admin can change attendance
//                           />
//                         </td>
//                       ))}
//                     </tr>
//                   ))
//               ) : (
//                 <tr>
//                   <td colSpan={meetings.length + 1}>No users available</td>
//                 </tr>
//               )}
//             </tbody>

//           </table>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ViewMeetings;

// import React, { useState, useEffect } from 'react';
// import './ViewMeetings.css';

// const ViewMeetings = () => {
//   const [meetings, setMeetings] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [attendance, setAttendance] = useState({});
//   const [userRole, setUserRole] = useState(""); // Store user role
//   const [userId, setUserId] = useState(""); // Store logged-in user's ID

//   useEffect(() => {
//     const savedAttendance = localStorage.getItem('attendance');
//     if (savedAttendance) {
//       setAttendance(JSON.parse(savedAttendance));
//     }

//     // Fetch user role & ID from local storage
//     const storedRole = localStorage.getItem('role'); // "admin" or "member"
//     const storedUserId = localStorage.getItem('userId');

//     setUserRole(storedRole);
//     setUserId(storedUserId);

//     const fetchMeetings = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });

//         if (!response.ok) throw new Error(`Error fetching meetings: ${response.status}`);

//         const data = await response.json();
//         setMeetings(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error(error);
//         setMeetings([]);
//       }
//     };

//     const fetchUsers = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });

//         if (!response.ok) throw new Error(`Error fetching users: ${response.status}`);

//         const data = await response.json();
//         setUsers(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error(error);
//         setUsers([]);
//       }
//     };

//     fetchMeetings();
//     fetchUsers();
//   }, []);

//   const handleAttendanceChange = async (meetingId, targetUserId, attended) => {
//     if (userRole !== "admin") return; // Only admin can modify attendance

//     setAttendance((prevState) => {
//       const updatedAttendance = { ...prevState };
//       if (!updatedAttendance[meetingId]) updatedAttendance[meetingId] = {};

//       if (attended) updatedAttendance[meetingId][targetUserId] = attended;
//       else delete updatedAttendance[meetingId][targetUserId];

//       localStorage.setItem('attendance', JSON.stringify(updatedAttendance));
//       return updatedAttendance;
//     });

//     try {
//       const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting/${meetingId}/attendance`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${localStorage.getItem('token')}`,
//         },
//         body: JSON.stringify({ userId: targetUserId, attended }),
//       });

//       const result = await response.json();
//       if (response.ok) console.log('✅ Attendance updated successfully:', result);
//       else console.error('❌ Error updating attendance:', result.message || 'Unknown error');
//     } catch (error) {
//       console.error('❌ Error updating attendance:', error);
//     }
//   };

//   return (
//     <div className="contain">
//       <main className="main-content">
//         <div className="review-meetings">
//           <h2>View Attendance</h2>

//           <table className="table-heading">
//             <thead>
//               <tr>
//                 {userRole === "admin" ? (
//                   <>
//                     <th>User Name</th>
//                     {meetings.map((meeting) => {
//                       const date = new Date(meeting.date);
//                       return (
//                         <th key={meeting._id}>
//                           {date.getDate()}-{date.toLocaleString('en-GB', { month: 'short' })}-{date.getFullYear()}
//                         </th>
//                       );
//                     })}
//                   </>
//                 ) : (
//                   <>
//                     <th>Date</th>
//                     <th>Attendance</th>
//                   </>
//                 )}
//               </tr>
//             </thead>

//             <tbody>
//               {users.length > 0 ? (
//                 userRole === "admin" ? (
//                   users.map((user) => (
//                     <tr key={user._id}>
//                       <td>{user.firstName} {user.lastName}</td>
//                       {meetings.map((meeting) => (
//                         <td key={meeting._id}>
//                           <input
//                             type="checkbox"
//                             checked={attendance[meeting._id]?.[user._id] ?? !!meeting.attendees?.find((att) => att.userId === user._id)?.attended}
//                             onChange={(e) => handleAttendanceChange(meeting._id, user._id, e.target.checked)}
//                             disabled={userRole !== "admin"}
//                           />
//                         </td>
//                       ))}
//                     </tr>
//                   ))
//                 ) : (
//                   meetings.map((meeting) => (
//                     <tr key={meeting._id}>
//                       <td>
//                         {new Date(meeting.date).getDate()}-
//                         {new Date(meeting.date).toLocaleString('en-GB', { month: 'short' })}-
//                         {new Date(meeting.date).getFullYear()}
//                       </td>
//                       <td>
//                         <input
//                           type="checkbox"
//                           checked={attendance[meeting._id]?.[userId] ?? !!meeting.attendees?.find((att) => att.userId === userId)?.attended}
//                           disabled={true} // Members cannot edit attendance
//                         />
//                       </td>
//                     </tr>
//                   ))
//                 )
//               ) : (
//                 <tr>
//                   <td colSpan={userRole === "admin" ? meetings.length + 1 : 2}>No users available</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ViewMeetings;







import React, { useState, useEffect } from 'react';
import './ViewMeetings.css';
import sortIcon from './images/sort.png';
import './OneToOneReview.css';
import './createadmin.css';

const ViewMeetings = () => {
  const [meetings, setMeetings] = useState([]);
  const [users, setUsers] = useState([]);
  const [userRole, setUserRole] = useState('');
  const [userId, setUserId] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    const storedUserId = localStorage.getItem('userId');
    setUserRole(storedRole);
    setUserId(storedUserId);
    fetchMeetings();
    fetchUsers();
  }, []);

  const fetchMeetings = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (!response.ok) throw new Error(`Error fetching meetings: ${response.status}`);
      const data = await response.json();
      setMeetings(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setMeetings([]);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (!response.ok) throw new Error(`Error fetching users: ${response.status}`);
      const data = await response.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setUsers([]);
    }
  };

  const handleAttendanceChange = async (meetingId, targetUserId, status) => {
    if (userRole !== 'admin') return;
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/meeting/${meetingId}/attendance`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ userId: targetUserId, status }),
      });

      const result = await response.json();
      if (response.ok) {
        await fetchMeetings();
      } else {
        console.error('❌ Error updating attendance:', result.message || 'Unknown error');
      }
    } catch (error) {
      console.error('❌ Error updating attendance:', error);
    }
  };

  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="contain">

      <main className="main-content">
        <h2 className="name">View/ Edit Attendance</h2>
        <div className="review-meetings">


          {/* Desktop table - Admin OR desktop view for member */}
          <div className="desktop-table-wrapper hide-on-mobile">
            <table className="table-heading">
              <thead>
                <tr>
                  {userRole === 'admin' ? (
                    <>
                      <th style={{ paddingLeft: '50px', paddingRight: '50px' }}>Name</th>
                      {meetings.map((meeting) => {
                        const date = new Date(meeting.date);
                        return (
                          <th key={meeting._id}>
                            {date.getDate()}-{date.toLocaleString('en-GB', { month: 'short' })}-{date.getFullYear()}
                          </th>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <th onClick={() => sortData('date')}>
                        Date
                        <img src={sortIcon} alt="Sort" />
                      </th>
                      <th>Attendance</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  userRole === 'admin' ? (
                    users.map((user) => (
                      <tr key={user._id}>
                        <td>{user.firstName} {user.lastName}</td>
                        {meetings.map((meeting) => {
                          const found = meeting.attendees?.find((e) => e.userId.toString() === user._id.toString());
                          return (
                            <td key={meeting._id}>
                              <select
                                value={found?.status ?? 'N/A'}
                                onChange={(e) =>
                                  handleAttendanceChange(meeting._id, user._id, e.target.value)
                                }
                              >
                                <option value="Present">Present</option>
                                <option value="Absent">Absent</option>
                                <option value="Substitute">Substitute</option>
                                <option value="N/A">N/A</option>
                              </select>
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  ) : (
                    meetings.map((meeting) => {
                      const found = meeting.attendees?.find((e) => e.userId.toString() === userId);
                      return (
                        <tr key={meeting._id}>
                          <td>
                            {new Date(meeting.date).getDate()}-{new Date(meeting.date).toLocaleString('en-GB', {
                              month: 'short',
                            })}-{new Date(meeting.date).getFullYear()}
                          </td>
                          <td>
                            <select value={found?.status ?? 'N/A'} disabled>
                              <option value="Present">Present</option>
                              <option value="Absent">Absent</option>
                              <option value="Substitute">Substitute</option>
                              <option value="N/A">N/A</option>
                            </select>
                          </td>
                        </tr>
                      );
                    })
                  )
                ) : (
                  <tr>
                    <td colSpan={userRole === 'admin' ? meetings.length + 1 : 2}>No users available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Scroll Table - Admin Only */}
          {userRole === 'admin' && (
            // <div className="mobile-scroll-table-wrapper show-on-mobile">
            <div className="mobile-scroll-table-add">
              <div className="mobile-scroll-wrapper">
                <table >
             
                    <tr>
                      <th className="sticky-col">Date</th>
                      {users.map((user) => (
                        <td key={user._id}>
                          {user.firstName} {user.lastName}
                        </td>
                      ))}
                    </tr>
                 
                  <tbody>
                    {meetings.map((meeting) => (
                      <tr key={meeting._id}>
                        <th className="sticky-col">
                          {new Date(meeting.date).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                          }).replace(/ /g, '-')}
                        </th>
                        {users.map((user) => {
                          const found = meeting.attendees?.find((e) => e.userId.toString() === user._id.toString());
                          return (
                            <td key={`${meeting._id}-${user._id}`}>
                              <select
                                value={found?.status ?? 'N/A'}
                                onChange={(e) => handleAttendanceChange(meeting._id, user._id, e.target.value)}
                                className="sticky-col"
                              >
                                <option value="Present">Present</option>
                                <option value="Absent">Absent</option>
                                <option value="Substitute">Substitute</option>
                                <option value="N/A">N/A</option>
                              </select>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* </div> */}
              </div>
              </div>
)}

            </div>
      </main>
    </div>
  );
};

export default ViewMeetings;
